import script from "./InputRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRecovery.vue?vue&type=script&setup=true&lang=js"

import "./InputRecovery.vue?vue&type=style&index=0&id=1bddbbff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bddbbff"]])

export default __exports__